import { styled } from "@mui/system";

import {
  // sideNavWidthSM,
  // sideNavWidthMD,
  // sideNavWidthLG,
  // sideNavWidthCollapsed,
  contentWidthSM,
  contentWidth
} from "../../../constants/styles";
import { ELITE, ISLAMIC, STANDART } from "../../../utils/useBlobColor/constants";

// Convert to actual styled components instead of returning style objects
export const FormLayoutContainer = styled("div")(({ theme, color }) => ({
  position: "relative",
  display: "flex",
  background: "var(--Color-Background-Secondary-Light)",
  marginTop: "6rem",
  // minHeight: "100vh",
  [theme.breakpoints.only("xs")]: {
    flexWrap: "wrap"
  },
  [theme.breakpoints.up("xl")]: {
    marginLeft: "auto",
    marginRight: "auto",
    "&:before": {
      content: "''",
      position: "fixed",
      zIndex: 11,
      left: 0,
      top: 0,
      width: "calc((100vw - 1920px) / 2 + 5px)",
      height: "100vh",
      background: () => {
        switch (color) {
          case ELITE:
            return "linear-gradient(to bottom, #8E2141, #B55774)";
          case ISLAMIC:
            return "#417C35";
          case STANDART:
            return "linear-gradient(to bottom, #E9320F, #EA1C44)";
          default:
            return "transparent";
        }
      }
    }
  }
}));

export const FormWrapper = styled("div")(({ theme, isSmallContentWidth }) => ({
  flexBasis: "0%",
  flex: "1 1 auto",
  minHeight: "0px",
  minWidth: "1px",
  margin: "0 auto",
  paddingTop: "1.5rem",
  transition: theme.transitions.create("all"),
  "& h2": {
    fontSize: "46px",
    fontWeight: "600",
    marginBottom: "20px",
    marginTop: "0",
    color: "#373737",
    [theme.breakpoints.only("xs")]: {
      fontSize: "27px"
    }
  }
}));

export const FormInner = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100%",
  padding: "0 15px",
  "& nextButton": {
    margin: "42px 0 0 !important"
  },
  [theme.breakpoints.only("xs")]: {
    paddingRight: 16,
    paddingLeft: 16
  },
  [theme.breakpoints.up("sm")]: {
    overflowY: "auto"
  }
}));

export const MainContainer = styled("div")(
  ({ theme, hasVerticalPagination, isSmallContentWidth }) => ({
    position: "relative",
    width: hasVerticalPagination ? "100%" : isSmallContentWidth ? contentWidthSM : contentWidth,
    minWidth: "40vw",
    maxWidth: "100%",
    margin: "0 auto",
    [theme.breakpoints.up("xl")]: {
      minWidth: "auto"
    },
    [theme.breakpoints.up("md")]: {
      width: "1128px"
    }
  })
);

export const MainContainerFullHeight = styled("div")({
  padding: "0 50px 0"
});
